'use client';

import { type MouseEvent, useCallback } from 'react';
import { dataLayerPush, getBaseUrlJoined, layoutEvents } from '@libs/analytics';
import { TextLink } from '@petsmart-ui/sparky';
import type { UsableNetAssistiveWindowType } from './types';
import './LegacyUsableNet.scss';

export const trackingData = (data: object) => Object.assign(data, { ...layoutEvents.headerClick });

export default function LegacyUsableNet() {
    const href = '#none';

    const handleA11YClick = useCallback((e: MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();

        dataLayerPush(
            trackingData({
                selection: 'Enable accessibility',
                link_url: getBaseUrlJoined(href),
            })
        );

        (window as UsableNetAssistiveWindowType).enableUsableNetAssistive?.();
    }, []);

    return (
        <TextLink href={href} className="legacy-usablenet__link UsableNetAssistive" onClick={handleA11YClick}>
            Enable accessibility
        </TextLink>
    );
}
